<template>
  <div class="number-info-content">
    <div class="number-info-input">
      <span>手机号：</span>
      <a-input
        size="large"
        style="width: 560px"
        v-model="info.mobile"
        placeholder="请输入手机号码"
      />
    </div>
    <div class="number-info-input">
      <span>密码：</span>
      <a-input-password
        size="large"
        style="width: 560px"
        v-model="info.password"
        placeholder="新的密码，长6-20位且数字、符号、字母至少包含两种"
      />
    </div>
    <div class="number-info-input">
      <span>验证码：</span>
      <a-input
        size="large"
        style="width: 424px"
        v-model="info.verifyCode"
        placeholder="请输入验证码"
      />
      <a-button
        @click="obtainSmsCode"
        :disabled="verifyCodeBtn"
        :class="{ 'btn-gray': verifyCodeBtn }"
      >
        {{ verifyCodeBtn ? reciprocalNum + "秒后重新发送" : "获取验证码" }}
      </a-button>
    </div>
  </div>
</template>

<script>
import { validatePwd } from "@/utils/utils";
import { resetPwdByMobile, sendMobileCode } from "@/api/common";

export default {
  name: "MobileRegister",
  data() {
    return {
      reciprocalNum: 60,
      verifyCodeBtn: false,
      checkSmscodData: {},
      info: {
        mobile: "",
        password: "",
        verifyCode: "",
      },
    };
  },
  methods: {
    // 获取手机验证码
    obtainSmsCode() {
      const { info } = this;
      if (!info.mobile || !info.password) {
        this.$message.warning("* 手机号或密码不能为空.");
        return;
      }
      // 长度验证
      if (info.mobile.length !== 11) {
        this.$message.warning("* 手机号输入有误.");
        return;
      }
      if (info.password.length < 6) {
        this.$message.warning("* 密码长度不足.");
        return;
      }
      this.verifyCodeBtn = true;
      sendMobileCode(info.mobile).then(() => {
        this.$message.success("发送成功!");
        this.reciprocalItme();
      });
    },
    reciprocalItme() {
      let num = this.reciprocalNum;
      let itme = setInterval(() => {
        num--;
        if (num <= 0) {
          this.verifyCodeBtn = false;
          this.reciprocalNum = 60;
          clearInterval(itme);
          return;
        }
        this.reciprocalNum = num;
      }, 1000);
    },
    submit() {
      const { info } = this;
      if (!info.mobile || !info.password) {
        this.$message.warning("* 手机号或密码不能为空.");
        return;
      }
      if (info.mobile.length !== 11) {
        this.$message.warning("* 手机号输入有误.");
        return;
      }
      if (info.password.length < 6 || info.password.length > 20) {
        this.$message.warning("* 密码长度必须是6-20位.");
        return;
      }
      if (!validatePwd(info.password)) {
        this.$message.warning("* 密码不符合要求.");
        return;
      }
      if (!info.verifyCode) {
        this.$message.warning("* 手机验证码不能为空.");
        return;
      }
      if (this.checkSmscodData.jfId) {
        this.$emit("success", this.checkSmscodData);
      } else {
        resetPwdByMobile(info)
          .then((res) => {
            this.checkSmscodData = res.data;
            this.$store
              .dispatch("Login", {
                username: this.info.mobile,
                password: this.info.password,
                grant_type: "password",
                scope: "server",
                type: "password",
              })
              .then(() => {
                this.$store.dispatch("GetInfo").then(() => {
                  this.$emit("success", this.checkSmsCodeData);
                });
              });
          })
          .catch((e) => {
            this.$message.warn(e.msg);
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.number-info-content {
  height: 456px;
  padding-top: 40px;

  .number-info-input {
    display: flex;
    margin-bottom: 32px;
    justify-content: space-between;

    > span {
      width: 90px;
      line-height: 40px;
    }

    > button {
      width: 120px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      color: #1abc9c;
    }
  }
}
</style>
